import React from 'react';
import logoImg from 'assets/logo.png';

function CoreSplashScreen()
{
	return (
		<div id="core-splash-screen">

			<div className="flex center">

				<div className="logo">
					<img width="128" src={logoImg} alt="logo"/>
				</div>
				<div className="spinner-wrapper">
					<div className="spinner">
						<div className="inner">
							<div className="gap"/>
							<div className="left">
								<div className="half-circle"/>
							</div>
							<div className="right">
								<div className="half-circle"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default React.memo(CoreSplashScreen);
